import React, { useState, useEffect } from "react";
import "./NewPost.css";
import { useNavigate } from "react-router-dom";
import { FaLock, FaGlobeAmericas } from "react-icons/fa";
import { getAuth } from "firebase/auth";

// Importing the images as backgrounds
import competitionBg from "../assets/competition-back-5.png";
import publicBg from "../assets/public-back.png";
import BottomNav from "./BottomNav";
import competitionManager from "../utils/competitionManager";
import RestrictionModal from "../components/RestrictionModal";

const formatTimeLeft = (time) => {
  if (time.days > 0) return `${time.days}d ${time.hours}h`;
  if (time.hours > 0) return `${time.hours}h ${time.minutes}m`;
  return `${time.minutes}m`;
};

const Add = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [restriction, setRestriction] = useState(null);

  useEffect(() => {
    let loadedCount = 0;
    const images = [competitionBg, publicBg];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = handleImageLoad;
      img.onerror = handleImageLoad;
    });

    function handleImageLoad() {
      loadedCount += 1;
      if (loadedCount === images.length) {
        setIsLoading(false);
      }
    }
  }, []);

  const handleCompetitionClick = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      navigate('/Login_page');
      return;
    }

    const time = competitionManager.getTimeRemaining();
    if (time.phase === 'break') {
      setRestriction({
        variant: 'break',
        stampText: 'On Break',
        message: `The competition is on a short break. Next competition starts in ${formatTimeLeft(time)}.`,
      });
      return;
    }

    const alreadyJoined = await competitionManager.isUserRegistered(user.uid);
    if (alreadyJoined) {
      setRestriction({
        variant: 'limit',
        stampText: 'One Entry Only',
        message: 'You can only join once per competition. Come back next round!',
      });
      return;
    }

    navigate("/TitleAndTagCompetition");
  };

  return (
    <>
      <div className="new-post-page-wrapper">
        <h2 className="new-post-heading">New post</h2>

        {/* NEW CONTAINER TO CENTER ONLY THE CARDS */}
        <div className="new-post-cards-container">
          {isLoading ? (
            /* SKELETON LOADERS */
            <>
              <div className="new-post-card skeleton-card skeleton-card--competition">

                <div className="skeleton-pill"></div>
              </div>
              <div className="new-post-card skeleton-card skeleton-card--public">

                <div className="skeleton-pill"></div>
              </div>
            </>
          ) : (
            /* ACTUAL CARDS */
            <>
              {/* SECTION 1: COMPETITION */}
              <div
                className="new-post-card new-post-card--competition"
                style={{ backgroundImage: `url(${competitionBg})` }}
                onClick={handleCompetitionClick}
              >

                <div className="new-post-pill new-post-pill--competition">
                  <div className="new-post-pill-title-row">
                    <FaLock className="new-post-pill-icon" />
                    <span className="new-post-pill-title">Enter &amp; Compete</span>
                  </div>
                  <span className="new-post-pill-price">Free to join</span>
                </div>
              </div>

              {/* SECTION 2: PUBLIC POST */}
              <div
                className="new-post-card new-post-card--public"
                style={{ backgroundImage: `url(${publicBg})` }}
                onClick={() => navigate("/TitleAndTag")}
              >

                <div className="new-post-pill new-post-pill--public">
                  <div className="new-post-pill-title-row">
                    <FaGlobeAmericas className="new-post-pill-icon" />
                    <span className="new-post-pill-title">Share &amp; Get Evolved</span>
                  </div>
                   <span className="new-post-pill-price">Open to everyone</span>

                </div>
              </div>
            </>
          )}
        </div>

        <RestrictionModal
          open={!!restriction}
          variant={restriction?.variant}
          stampText={restriction?.stampText}
          message={restriction?.message}
          onClose={() => setRestriction(null)}
        />
      </div>

      <BottomNav />
    </>
  );
};

export default Add;